import $ from "jquery";
import React, { Suspense, useState } from 'react';


// Context

// Import
import AllOrders from "./AllOrders";
import AllVoucher from "./AllVoucher";
import UserBasicInfoQRContext from "../../../components/Context/UserBasicInfoQRContext";
import { useContext } from "react";



export default function Order() {

    const companyInfo = useContext(UserBasicInfoQRContext);

    const [currentTab, setCurrentTab] = useState("shop");

    const handleTab = (tabId, event) => {
        $(".tablinks").removeClass("current");
        $(event.target).addClass("current");
        setCurrentTab(tabId);
    }


    return (
        <div className="custom-container w-full float-left px-8 py-10 pt-4 block font-montserrat custom-scroll-auto mb-20 ">

        {(companyInfo?.id === null || companyInfo?.id === "" || companyInfo?.id === undefined) 
            ?
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            Before proceeding, please select a company.
                        </td>
                    </tr>
                </tbody>
            </table>
            :
            <>

                <div className="tab w-full">
                    <button className="tablinks current" onClick={(event) => handleTab("shop", event)}>Shop History&nbsp;</button>
                    <button className="tablinks " onClick={(event) => handleTab("voucher", event)}>Voucher History</button>
                </div>

                <div className='tabcontentbody py-3'>
                    <div id="view-profile" className="tabcontent" style={{ display: "block", paddingLeft: "0px" }}>
                        <Suspense fallback="Loading...">


                            {(() => {
                                switch (currentTab) {
                                    case "shop":
                                        return <AllOrders></AllOrders>
                                    case "voucher":
                                        return <AllVoucher></AllVoucher>
                                    default:
                                        return <h1>No page found.</h1>
                                }
                            })()}



                        </Suspense>
                    </div>
                </div>


            </>
        }

        </div>
    )

}
